import { AlertCircle } from "lucide-react";

const PendingDashboard = ({ employee, hasRejectedDocument,rejectedDocuments = [] }) => {
  const message = hasRejectedDocument
    ? {
        title: "Document Issue Detected",
        text: rejectedDocuments.length
          ? `The following documents are missing or rejected: ${rejectedDocuments.join(", ")}. Please re-upload them to continue.`
          : "Some of your documents were rejected. Please re-upload the required files.",
        color: "text-red-600",
      }
    : {
        title: "Thank You!",
        text: "Thank you for uploading your documents. Your application is under review. Please wait for approval.",
        color: "text-amber-600 dark:text-amber-400",
        icon: "⏳",
      };
  return (
    <div className="relative min-h-screen">
      {/* Blurred Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-gray-50 to-gray-100 dark:from-slate-900 dark:to-slate-800 blur-sm opacity-50" />

      <div className="relative z-10 mb-8 bg-gradient-to-r from-amber-400 via-amber-300 to-amber-200 dark:from-amber-900 dark:via-amber-800 dark:to-amber-700 rounded-lg p-8 shadow-md">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
          Welcome Back, {employee.fullName}
        </h1>
        <p className="text-gray-700 dark:text-gray-200 mt-2 font-medium">
          Hazer Global Employee Dashboard Portal
        </p>
      </div>

      {/* Centered Modal/Popup */}
   <div className="fixed inset-0 flex items-center justify-center z-50 pointer-events-none pt-32">
  <div className="pointer-events-auto w-full max-w-md mx-4"> {/* reduced max width */}
    <div className="relative">
      {/* Animated border background */}
      <div className="absolute inset-0 rounded-2xl animated-border-glow opacity-100" />

      {/* Main content */}
      <div className="relative bg-white dark:bg-slate-800 rounded-2xl shadow-2xl p-6 border-2 border-transparent">
        {/* Alert Icon */}
        <div className="flex justify-center mb-4">
          <div className="p-3 bg-amber-100 dark:bg-amber-900/30 rounded-full">
            <AlertCircle className="w-6 h-6 text-amber-600 dark:text-amber-400" />
          </div>
        </div>

        {/* Centered Message Card */}
        <div className="bg-gradient-to-br from-blue-50 to-blue-100 dark:from-blue-900/20 dark:to-blue-800/20 rounded-xl p-4 border border-blue-200 dark:border-blue-700 text-center z-20">
          <h3
            className={`text-lg font-semibold mb-2 text-center ${message.color}`}
          >
            {message.icon} {message.title || "Document Issue Detected"}
          </h3>
          <p className="text-gray-700 dark:text-gray-300 text-center leading-relaxed mb-3">
            {message.text || "Some of your documents could not be verified. Please review and upload again."}
          </p>
          {hasRejectedDocument && (
            <a
              href="/upload-documents"
              className="inline-block bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
            >
              Re-upload Documents
            </a>
          )}
        </div>
      </div>
    </div>
  </div>
</div>
    </div>
  );
};

export default PendingDashboard;
